import { get, post } from "sr/utils/axios";

export const getCleanerLatestBackgroundCheck = async () =>
  get<any>("/checkr/cleaner/latest");

export const downloadCleanerBackgroundCheckReport = async () =>
  get<any>("/checkr/cleaner/report");

export const downloadCleanerBackgroundCheckReportDocument = async (
  documentIndex: number,
) =>
  get<Blob>(
    `/checkr/cleaner/report/document/${documentIndex}`,
    {},
    { responseType: "blob" },
  );

export const startCleanerBackgroundCheck = async (data: {
  packageId: string;
  paymentMethodId: string;
}) => post<any>("/checkr/cleaner/start", data);
